import { useMemo } from 'react';
import { ConfirmationDialogue, LoadingIndicator, LockedFeatureDialogue, useTranslationSetup } from 'vopay';
import { useHistory } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { useConfirmationDialogue } from './providers/ConfirmationDialogue.provider';
import { usePartnerLogin } from './providers/PartnerLogin.provider';
import useDataFetchIndicator from './hooks/useDataFetchIndicator';
import { useLockedFeatureDialogue } from './providers/LockedFeatureDialogue.provider';
import styles from './App.module.scss';

const App = () => {
  useTranslationSetup();
  const dialogueProps = useConfirmationDialogue();
  const history = useHistory();
  const { isAuthenticated } = usePartnerLogin();
  const [[isFetchingData, loadingMessage, indicator, isDataFetchingStickey]] = useDataFetchIndicator();
  const { isLocked, updateIsLocked, lockedFeature } = useLockedFeatureDialogue();

  return (
    <div className={styles.app}>
      {useMemo(
        () => (
          <ConfirmationDialogue {...dialogueProps} />
        ),
        [dialogueProps],
      )}
      {useMemo(
        () => (
          <LoadingIndicator
            isVisible={(isFetchingData || !!isDataFetchingStickey) && indicator === 'fullScreen'}
            message={loadingMessage}
            size="lg"
            noLeadingDots
            hasNoMessage
            hasNoTitle
          />
        ),
        [isFetchingData, isDataFetchingStickey],
      )}
      {useMemo(
        () => (
          <LockedFeatureDialogue
            lockedFeature={lockedFeature}
            isVisible={isLocked}
            cancel={() => updateIsLocked(false, '')}
            contactOutTeam={() => {
              history.push({
                pathname: '/tickets-create',
                state: { ticketSubject: `Enquiry about ${lockedFeature} feature` },
              });
              updateIsLocked(false, '');
            }}
          />
        ),
        [isLocked],
      )}

      {isAuthenticated === null ? null : isAuthenticated === false ? <Login /> : <Dashboard />}
    </div>
  );
};

export default App;
